// A color identity per map: two stops of a gradient and an accent. Drawn,
// not photos (map artwork belongs to Valve).
type MapTheme = { from: string; to: string; accent: string };

const THEMES: Record<string, MapTheme> = {
  de_mirage: { from: "#b9803f", to: "#3b2512", accent: "#f0c27b" },
  de_inferno: { from: "#b8452f", to: "#3a120c", accent: "#ff8a5c" },
  de_dust2: { from: "#c79a55", to: "#43301a", accent: "#f3d08e" },
  de_nuke: { from: "#2f8f9a", to: "#0f2c33", accent: "#6fe0e8" },
  de_ancient: { from: "#3f8a55", to: "#11281a", accent: "#86e0a0" },
  de_anubis: { from: "#2f6fae", to: "#1b2238", accent: "#e6c36a" },
  de_vertigo: { from: "#5f8fbf", to: "#1a2a3c", accent: "#b9dcff" },
  de_overpass: { from: "#5f8a64", to: "#1e2d22", accent: "#b6e3a4" },
  de_train: { from: "#7c8593", to: "#23282f", accent: "#d0d7e2" },
  de_cache: { from: "#5f9b45", to: "#1c2e15", accent: "#c3f08f" },
  de_office: { from: "#8a8f9f", to: "#262833", accent: "#e1e6f5" },
  de_italy: { from: "#c46f4b", to: "#3d1f14", accent: "#ffc19a" },
};
const FALLBACK: MapTheme = { from: "#3a4658", to: "#131a24", accent: "#c9d4e3" };

export const mapTheme = (map: string | null | undefined): MapTheme => THEMES[map ?? ""] ?? FALLBACK;
